<template>
  <div class="defaultViewStyle">
    <page-header />
    
    <div class="main-content">
      <div class="setup-container" style="overflow-y: scroll">
        <!-- 系统配置区 -->
        <section class="setup-section">
          <div class="section-header">
            <div class="header-icon">
<!--              <image src="" />-->
              <i class="el-icon-setting"></i>
            </div>
            <div class="header-content">
              <h2>系统配置</h2>
              <div class="connection-status" :class="{ 'is-connected': linkType }">
                {{ linkType ? '系统已连接' : '未连接' }}
              </div>
            </div>
          </div>

          <div class="setup-form">
            <div class="form-item">
              <label class="required">ERP系统版本</label>
              <el-select 
                v-model="erp.thirdVersion" 
                placeholder="请选择系统版本"
                @change="handleChange"
              >
                <el-option
                  v-for="(item, index) in thirdVersions"
                  :key="index"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </div>
          </div>
        </section>

        <!-- 数据库配置区 -->
        <section class="setup-section">
          <div class="section-header">
            <div class="header-icon">
              <i class="el-icon-connection"></i>
            </div>
            <div class="header-content">
              <h2>数据库配置</h2>
            </div>
          </div>

          <div class="setup-form">
            <div class="form-item">
              <label class="required">主机地址</label>
              <el-input 
                v-model="erp.thirdDatabaseIp"
                placeholder="请输入主机地址"
              />
            </div>

            <div class="form-item">
              <label class="required">端口号</label>
              <el-input 
                v-model="erp.thirdDatabasePort"
                placeholder="请输入端口号"
              />
            </div>

            <div class="form-item">
              <label class="required">用户名</label>
              <el-input 
                v-model="erp.thirdDatabaseUser"
                placeholder="请输入用户名"
              />
            </div>

            <div class="form-item">
              <label class="required">密码</label>
              <div class="input-group">
                <el-input 
                  v-model="erp.thirdDatabasePassword"
                  type="password"
                  placeholder="请输入密码"
                  show-password
                />
                <el-button style="height: 41px" type="primary" @click="testLink">测试连接</el-button>
              </div>
            </div>

            <div class="form-item">
              <label class="required">数据库实例</label>
              <div class="input-group">
                <el-select 
                  v-model="erp.thirdDatabaseName"
                  placeholder="请选择数据库"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="(item, index) in dataBase"
                    :key="index"
                    :label="item"
                    :value="item"
                  />
                </el-select>
                <el-button type="primary" @click="link">连接</el-button>
              </div>
            </div>
          </div>
        </section>

        <!-- 默认配置区 -->
        <section class="setup-section">
          <div class="section-header">
            <div class="header-icon">
              <i class="el-icon-user"></i>
            </div>
            <div class="header-content">
              <h2>默认配置</h2>
            </div>
          </div>

          <div class="setup-form">
            <div class="form-item">
              <label class="required">默认制单人</label>
              <el-select 
                v-model="erp.thirdDefaultOperator"
                placeholder="请选择制单人"
                clearable
              >
                <el-option
                  v-for="(item, index) in thirdOperators"
                  :key="index"
                  :label="item.name"
                  :value="item.thirdKeyBackup"
                />
              </el-select>
            </div>

            <div class="form-item">
              <label class="required">默认仓库</label>
              <el-select 
                v-model="erp.defaultStock"
                placeholder="请选择仓库"
                clearable
              >
                <el-option
                  v-for="(item, index) in stocks"
                  :key="index"
                  :label="item.name"
                  :value="item.thirdKeyBackup"
                />
              </el-select>
            </div>
          </div>
        </section>
      </div>
    </div>

    <!-- 底部操作栏 -->
    <div class="action-bar">
      <el-button @click="resetForm">重置</el-button>
      <el-button type="primary" @click="onSubmit">保存配置</el-button>
    </div>
  </div>
</template>

<script>
import erpApi from "@/api/main/sync/erpConfigApi";
import PageButton from "@/components/h5/button/PageButton.vue";
import PageHeader from "@/components/h5/layout/PageHeader.vue";

export default {
  name: "ErpRelation",
  components: {
    PageButton,
    PageHeader
  },
  data() {
    return {
      erp: {
        thirdVersion: "",
        thirdDatabaseIp: "",
        thirdDatabasePort: "",
        thirdDatabaseUser: "",
        thirdDatabasePassword: "",
        thirdDatabaseName: "",
        thirdDefaultOperator: "",
        defaultStock: ""
      },
      linkType: false,
      thirdVersions: [],
      dataBase: [],
      thirdOperators: [],
      stocks: []
    };
  },
  created() {
    this.queryAllVersions();
  },
  methods: {
    queryAllVersions() {
      erpApi.queryAllVersions().then(res => {
        this.thirdVersions = res;
        this.findThirdConfig();
      });
    },
    findThirdConfig() {
      erpApi.findThirdConfig().then(res => {
        if (res.thirdVersion) {
          this.erp = res;
          this.linkType = !!res.reachConnect;
          this.testOperatorLink();
          this.testStockLink();
        }
      });
    },
    handleChange(value) {
      const selectedVersion = this.thirdVersions.find(v => v.code === value);
      if (selectedVersion) {
        this.erp.thirdVersionNumber = selectedVersion.name;
      }
    },
    testLink() {
      erpApi.testLink(this.erp).then(res => {
        this.dataBase = res;
        this.$message.success('连接测试成功');
      });
    },
    link() {
      this.testOperatorLink();
      this.testStockLink();
      this.$message.success('数据库实例连接成功');
    },
    testOperatorLink() {
      erpApi.testOperatorLink(this.erp).then(res => {
        this.thirdOperators = res;
      });
    },
    testStockLink() {
      erpApi.testStockLink(this.erp).then(res => {
        this.stocks = res;
      });
    },
    resetForm() {
      this.erp = {
        thirdVersion: "",
        thirdDatabaseIp: "",
        thirdDatabasePort: "",
        thirdDatabaseUser: "",
        thirdDatabasePassword: "",
        thirdDatabaseName: "",
        thirdDefaultOperator: "",
        defaultStock: ""
      };
    },
    onSubmit() {
      erpApi.save(this.erp).then(() => {
        // this.$message.success('配置保存成功');
        this.findThirdConfig();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  min-height: 100vh;
  background-color: #f8fafc;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding: 24px 24px 0;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
    
    &:hover {
      background: #94a3b8;
    }
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.setup-container {
  max-width: 800px;
  margin: 0 auto;
}

.setup-section {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 24px;
  height: 100%;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
                0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .section-header {
    padding: 20px 24px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e5e7eb;
    background: linear-gradient(to right, rgba(59, 130, 246, 0.05), transparent);

    .header-icon {
      width: 40px;
      height: 40px;
      border-radius: 10px;
      background: linear-gradient(135deg, #3b82f6, #60a5fa);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 16px;

      i {
        font-size: 20px;
        color: #ffffff;
      }
    }

    .header-content {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;

      h2 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #1e293b;
      }
    }
  }
}

.connection-status {
  font-size: 14px;
  padding: 6px 12px;
  border-radius: 6px;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;

  &.is-connected {
    background: rgba(34, 197, 94, 0.1);
    color: #16a34a;
  }
}

.setup-form {
  padding: 24px;

  .form-item {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    label {
      display: block;
      margin-bottom: 8px;
      color: #475569;
      font-size: 14px;
      font-weight: 500;

      &.required:before {
        content: "*";
        color: #ef4444;
        margin-right: 4px;
      }
    }

    .input-group {
      display: flex;
      gap: 12px;

      :deep(.el-input),
      :deep(.el-select) {
        flex: 1;
      }

      .el-button {
        width: 100px;
      }

      :deep(.el-button):nth-child(1){
        height: 41px !important;
      }
    }
  }
}

:deep(.el-input),
:deep(.el-select) {
  .el-input__inner {
    border: none;
    height: 40px;
    line-height: 40px;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
      border-color: #3b82f6;
    }

    &:focus {
      border-color: #3b82f6;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
  }
}

.action-bar {
  padding: 16px 24px;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: center;
  gap: 12px;
  z-index: 10;

  .el-button {
    min-width: 120px;
    height: 40px;
    font-weight: 500;
    
    &--primary {
      background: linear-gradient(135deg, #3b82f6, #60a5fa);
      border: none;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 6px rgba(59, 130, 246, 0.2);
      }
    }

    &--default {
      &:hover {
        border-color: #3b82f6;
        color: #3b82f6;
      }
    }
  }
}
</style>